import type { FilterIds } from '~/types/FilterIds'
import type { FilterDefinition } from '~/utils/serviceSearch/types/FilterDefinition'

export const useSelectedSupportNeedCategories = () => {
  const { filters } = useServiceSearchStore()
  const { supportNeedCategories } = storeToRefs(useSupportNeedCategoryStore())

  const selectedSupportNeedCategories = computed<FilterDefinition<FilterIds>[]>(() => {
    return filters.supportNeeds.map((supportNeed) => {
      const fullSupportNeed = supportNeedCategories.value.find((category) => category.uid === supportNeed)
      const filter: FilterDefinition<FilterIds> = {
        selected: true,
        label: fullSupportNeed?.displayText || supportNeed,
        key: `support-needs:${supportNeed}`,
        filterId: `support-needs:${supportNeed}`,
        unselect: () => {
          filters.supportNeeds = filters.supportNeeds.filter((p) => p !== supportNeed)
        }
      }

      return filter
    })
  })

  return { selectedSupportNeedCategories }
}
